/**
 * @generated SignedSource<<ba8012426fe7f65543a5b2874e48c8ca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NativeIssueTableWithSelectedIssuesProvider950BadPattern$data = {
  readonly __id: string;
  readonly groupByField: string | null | undefined;
  readonly jql: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRealtimeUpdater953BadPattern" | "IssueTable28BadPattern" | "RealtimeUpdater705BadPattern">;
  readonly " $fragmentType": "NativeIssueTableWithSelectedIssuesProvider950BadPattern";
};
export type NativeIssueTableWithSelectedIssuesProvider950BadPattern$key = {
  readonly " $data"?: NativeIssueTableWithSelectedIssuesProvider950BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider950BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isPaginating"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    }
  ],
  "kind": "Fragment",
  "name": "NativeIssueTableWithSelectedIssuesProvider950BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "groupByField"
    },
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isLinkRelationshipFieldEnabled",
          "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
          "kind": "Variable",
          "name": "isPaginating",
          "variableName": "isPaginating"
        },
        {
          "kind": "Variable",
          "name": "isTimelineEnabled",
          "variableName": "isTimelineEnabled"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueTable28BadPattern"
    },
    {
      "kind": "FragmentSpread",
      "name": "RealtimeUpdater705BadPattern"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "IssueRealtimeUpdater953BadPattern"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};

(node as any).hash = "7b5e2e6eb4bf308fbc467cb2e3ba36cd";

export default node;
